/* ============
 * Vuex Store
 * ============
 *
 * The store of the application.
 *
 * http://vuex.vuejs.org/en/index.html
 */

import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import audit from './audit';
import authority from './authority';
import customer from './customer';
import common from './common';
import backstage from './backstage';
import statistics from './statistics';
import visit from './visit';
import business from './business';
import compact from './compact';
import compactInside from './compactInside';
import user from './user';
import base from './base';
import clue from './clue';
import knowledge from './knowledge';
import project from './project';

Vue.use(Vuex);

export default new Vuex.Store({
  /**
   * Assign the modules to the store
   */
  modules: {
    audit,
    authority,
    customer,
    common,
    backstage,
    statistics,
    visit,
    business,
    compact,
    user,
    base,
    clue,
    knowledge,
    project,
    compactInside,
  },

  /**
   * If strict mode should be enabled
   */
  strict: false,
});
